<section class="auction-add-batch">
  <div class="container-fluid">
    <div class="auction-content-main">
      <div class="auction-content-header px-4 pt-4 pb-2">
        <h4 class="fs-lg color-ashen-med">Add New Batch</h4>
      </div>
      <div class="auction-content-body p-4">
        <form
          class="auction-add-batch__form credential2"
          [formGroup]="addBatchForm"
          (submit)="addBatch()"
        >
          <div class="row mx-n2 mb-4">
            <div class="col-md-6">
              <div class="form-group">
                <label for="" class="credential2__label">Batch Name</label>
                <input
                  type="text"
                  name="name"
                  formControlName="name"
                  class="credential2__input form-control"
                  [class.is-invalid]="formData['name'].errors && submitted"
                />
                <div class="invalid-feedback">
                  <p>Batch name should not be empty.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="" class="credential2__label"
                  >Arabic Batch Name</label
                >
                <input
                  type="text"
                  name="name"
                  formControlName="arabic_name"
                  class="credential2__input form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="" class="credential2__label">Location</label>
                <input
                  type="text"
                  name="location"
                  formControlName="location"
                  class="credential2__input form-control"
                  [class.is-invalid]="formData['location'].errors && submitted"
                />
                <div class="invalid-feedback">
                  <p>Please mention the Location.</p>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="" class="credential2__label">Description</label>
                <textarea
                  name="description"
                  formControlName="description"
                  class="credential2__textarea form-control"
                  placeholder="Enter description"
                  [class.is-invalid]="
                    formData['description'].errors && submitted
                  "
                ></textarea>
                <div class="invalid-feedback">
                  <p>Please write a description.</p>
                </div>
              </div>
            </div>

            <div class="col-sm-6 col-md-4 col-xl-2 px-2">
              <div class="form-group position-relative">
                <label for="vehicle_1" class="credential__file">
                  <input
                    type="file"
                    accept="image/*"
                    name="vehicle_1"
                    id="vehicle_1"
                    class="form-control d-none"
                    (change)="getProfileImage($event, 1)"
                    [class.is-invalid]="(!imageInfo?.['image'] ||  imageInfo?.['image'] === '') && submitted"
                  />
                  <img src="{{ env }}assets/img/add-image.svg" alt="" />
                  <div class="mt-2 invalid-feedback">
                    <p>Please provide a photo.</p>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-sm-6 col-md-4 col-xl-2 px-2">
              <div
                class="form-group position-relative add-user-img"
                [ngClass]="imageUrl ? 'd-block' : 'd-none'"
              >
                <button
                  type="button"
                  class="btn-close close pull-right"
                  [swal]="{
                    title: 'Are You Sure?',
                    icon: 'question',
                    showDenyButton: false,
                    denyButtonText: 'Don\'t save',
                    showCancelButton: true
                  }"
                  (confirm)="deleteImage(true)"
                  (dismiss)="handleDismiss($event)"
                >
                  <span aria-hidden="true" class="visually-hidden"
                    ><ion-icon name="close-outline"></ion-icon
                  ></span>
                </button>
                <input
                  type="file"
                  name="vehicle_2"
                  id="vehicle_2"
                  class="form-control d-none"
                />
                <img [src]="imageUrl" alt="image" />
              </div>
            </div>
          </div>

          <!-- Production Purpose Only Jan 2 -->

          <div class="row mx-n2" *ngIf="attributeList.length">
            <div class="col-3 col-sm-3 col-md-3">
              <div class="credential2__input-group position-relative">
                <label class="credential2__label add-product">
                  Add Product
                </label>

                <select
                  name=""
                  id=""
                  class="auction-add-batch__select main-select form-control"
                  (change)="selectSearchOption($event)"
                  [class.is-invalid]="
                    !allSelectedListedProduct.length && submitted
                  "
                >
                  <option value="">Select</option>
                  <option
                    [value]="attributes"
                    *ngFor="let attributes of attributeList"
                  >
                    {{ attributes | titlecase }}
                  </option>
                </select>
                <div class="mt-5 ml-2 invalid-feedback">
                  <p>Please add a product.</p>
                </div>
              </div>
            </div>
            <div class="col-9 col-md-9 col-sm-9 px-2">
              <div class="form-group position-relative">
                <label class="credential2__label mt-2"> </label>
                <div class="credential2__input-group">
                  <span class="auction-add-batch__icon">
                    <ion-icon name="search-outline" class="ion-lg"></ion-icon>
                  </span>
                  <input
                    type="text"
                    name=""
                    (input)="openproductlist($event)"
                    class="auction-add-batch__icon-input form-control"
                    placeholder="Type a VIN or a Make or a Model"
                  />

                  <div
                    *ngIf="isSearching"
                    class="
                      lodding-spinner-border
                      text-dark
                      auction-add-batch__loader
                    "
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3 col-sm-3 col-md-3"></div>
            <div
              class="show-inventory-list col-9 col-md-9 col-sm-9 px-2"
              id="ProductList"
              *ngIf="allListedProduct.length"
            >
              <div
                class="show-inventory-list__listouter"
                style="border-bottom: 1px solid #909090"
              >
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Photo</th>
                      <th>Registration number</th>
                      <th>VIN number</th>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Trim</th>
                      <th>Year</th>
                      <th>Mileage</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let batch of allListedProduct; index as i">
                      <td>
                        <div class="show-inventory-list__featureImage">
                          <img [src]="batch['frontImg']" alt="" />
                        </div>
                      </td>

                      <td>
                        {{batch?.['description_data']?.['Plate Number'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['VIN Number'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['Make'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['Model'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['Trim/Type'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['Model Year'] || '--'}}
                      </td>

                      <td>
                        {{batch?.['description_data']?.['ODO'] || '--'}}
                      </td>

                      <td>
                        <!-- <div *ngIf="batch?.['added']; else addBtnOption">
                          <img src="{{ env }}assets/img/checkmark-flat.svg" />
                        </div> -->

                        <!-- <ng-template #addBtnOption>
                        </ng-template> -->

                        <button
                          type="button"
                          class="show-inventory-list__addBtn"
                          [disabled]="batch?.added"
                          [style.width.px]="75"
                          [style.cursor]="
                            batch?.added ? 'not-allowed' : 'pointer'
                          "
                          (click)="addProduct(batch)"
                        >
                          {{batch?.['added'] ? 'Added' : 'Add'}}
                        </button>

                        <!-- <img src="{{ env }}assets/img/add-image.svg" alt="" /> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-12 px-2">
              <div class="auction-add-batch__addedBatches">
                <div class="row mx-n2">
                  <div
                    class="col-md-4 col-lg-3 px-2"
                    *ngFor="let batch of allSelectedListedProduct; index as i"
                  >
                    <figure class="batch-card position-relative">
                      <input
                        type="checkbox"
                        class="customCheckBox"
                        [checked]="batch['product_id']"
                        id="cb{{ i }}"
                        name="cb"
                        (click)="selectedItem($event, batch['product_id'])"
                      />
                      <label for="cb{{ i }}"> </label>
                      <div class="batch-card__thumb">
                        <ng-container>
                          <img [src]="batch['frontImg']" />
                        </ng-container>
                      </div>
                      <figcaption class="batch-card__caption">
                        <h4 class="fs-normal text-truncate fw-600 mb-2">
                          {{
                            batch["description_data"]["Model Year"] +
                              " " +
                              batch["description_data"]["Make"] +
                              " " +
                              batch["description_data"]["Model"]
                          }}
                        </h4>
                        <p class="fs-normal text-truncate fw-50 fs-sm mb-2">
                          VIN: {{ batch["description_data"]["VIN Number"] }}
                        </p>
                        <p class="fs-normal text-truncate fw-50 fs-sm mb-2">
                          Reg: {{ batch["description_data"]["Plate Number"] }}
                        </p>
                        <div class="batch-card__captionInfo">
                          <span
                            class="
                              info
                              fs-sm
                              color-gray
                              text-truncate
                              font-italic
                              border-right
                              w-50
                              pr-2
                            "
                          >
                            {{
                              batch["description_data"]["Vehicle Type"] ||
                                batch["description_data"]["Vehicle type"]
                            }}
                          </span>
                          <span class="info fs-sm text-truncate w-50 pl-2">{{
                            batch["description_data"]["Max Speed"] ||
                              batch["description_data"]["Max speed"]
                          }}</span>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 px-2">
              <div class="auction-add-batch__btnGrp ml-auto">
                <button
                  type="submit"
                  class="btn btn__main curved w-100"
                  [ladda]="laddaLoading"
                >
                  {{ batchId ? "UPDATE BATCH" : "CREATE BATCH" }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<app-loader *ngIf="loading"></app-loader>
